import { WithResourceId } from '@mews-commander/types';
import { useResourcesCategoriesQuery } from './useResourcesCategoriesQuery';

export type UseResourceCategoryNameParams = WithResourceId;

export const useResourceCategoryName = ({ resourceId }: UseResourceCategoryNameParams) => {
    const { data, isFetching } = useResourcesCategoriesQuery();

    // @ts-expect-error 'string' can't be used to index type 'EnforceKeyableRecord<ResourceCategoryAssignment, "resourceId">
    const resourceCategoryId: string | undefined = data?.resourceCategoryAssignments?.[resourceId]?.categoryId;
    const resourceCategory = resourceCategoryId ? data?.resourceCategories?.[resourceCategoryId] : undefined;

    return {
        isFetching,
        resourceCategoryName: resourceCategory?.name,
        resourceCategoryShortName: resourceCategory?.shortName,
    };
};
